import React from 'react';
import { Select } from 'antd';
import { AcvtSupportedLanguages } from '../../../../types/acvt';
import { useT } from '../../../preview';
import style from './style.module.scss';

const { Option } = Select;

export const AcvtInStorePage = (props: {
    /**
     * Kept for backward compatibility — strings come from `useT()`.
     */
    language?: AcvtSupportedLanguages;
    cards: React.ReactNode;
    categoriesList?: (string | undefined | null)[];
    selectedCategory: string | undefined;
    changeCategories: (selection: string) => void;
}) => {
    const t = useT();

    return (
        <div className={style.page_container}>
            <div className={style.selector_container}>
                <Select
                    placeholder={t.promotions.categoriesPlaceholder}
                    allowClear
                    style={{ width: 320 }}
                    onChange={props.changeCategories}
                    defaultValue={props.selectedCategory}
                >
                    {props.categoriesList?.map((category) => (
                        <Option key={`${category}`} value={`${category}`}>
                            {category}
                        </Option>
                    ))}
                </Select>
            </div>
            <div className={style.instore_content}>
                <h3 className={style.header}>{t.promotions.inStoreHeading}</h3>
                {props.cards}
            </div>
        </div>
    );
};
